import { Controller } from '../utils/controller';
import { iframeResizer } from 'iframe-resizer';
import productController from './product_controller';

export default class extends Controller {
  static targets = ['output'];
  static requiredTargets = [];

  declare outputTarget: HTMLElement;
  declare readonly hasOutputTarget: boolean;

  // LOCAL STATE
  private resizer: iframeResizer;

  getHeightCalcMethod() {
    const iframeSrc = this.element?.children?.[0]?.src;

    // The 'taggedElement' requires the iframe to contain attribute data-iframe-height="iFrameResizer"
    // The 'bodyScroll' calculates the iframe height with a MutationObserver but the CPU is heavy (VUL-11258)
    return /\/iframe\/|=iframe\//.test(iframeSrc) ? 'taggedElement' : 'bodyScroll';
  }

  initialize() {
    if (this.hasOutputTarget) {
      this.resizer = iframeResizer(
        {
          checkOrigin: false,
          heightCalculationMethod: this.getHeightCalcMethod(),
          log: false,
          tolerance: 50,
          waitForLoad: true,
          warningTimeout: 0,
          onScroll: () => {
            return false;
          },
          onMessage: ({ message }) => {
            const data = typeof message === 'string' ? JSON.parse(message) : message;
            const { scrollY = 0, scrollTarget = '', scrollPadding = 0 } = data;
            const action = data?.['_elc_action'] || '';
            const actionName = data?.['_elc_analytics_action_name'] || '';
            const actionLabel = data?.['_elc_analytics_action_label'] ?? actionName?.split('_')[1] ?? '';
            const target = scrollTarget && document.querySelectorAll(scrollTarget);

            switch (action) {
              case 'addtobag':
              case 'addtobagV2': {
                const product = new productController(data.$addBtn);
                product.selectedskuValue = data.skuBaseId;
                product.quantityValue = data.INCREMENT || data.quantity;
                product.iframeId = data.iframeID;
                action === 'addtobag' ? product.addToCart() : product.addToCartV2();
                break;
              }
              case 'selectShade':
                document.getElementById(data.skuBaseId)?.click();
                break;
              case 'scrollIntoView': {
                const top =
                  (target?.length ? target[0].offsetTop : scrollY) - Number(scrollPadding);
                window.scrollTo({
                  top,
                  behavior: 'smooth'
                });
                break;
              }
              case 'openAppointmentBooking': {
                if (typeof window.ElcAppointmentBooking?.openBooxi === 'function') {
                  window.ElcAppointmentBooking.openBooxi();
                } else {
                  console.error(
                    'ElcAppointmentBooking not loaded from appointment_booking_booxi.ts hook.'
                  );
                }
                break;
              }
              case 'openSalesforceChat':
                window?.openSalesforceChat?.();
                break;
              case 'openLiveChat':
                window?.LiveChat?.onBeautyChatButtonClick?.();
                break;
              case 'openVTO': {
                const targetClassName = data?.targetClassName;
                if (typeof targetClassName === 'string' && targetClassName.trim() !== '') {
                  const elements = document.getElementsByClassName(targetClassName);
                  const vtoElement = elements[0] as HTMLElement | undefined;
                  if (vtoElement && typeof vtoElement.click === 'function') {
                    vtoElement.click();
                  }
                }
                break;
              }
              case 'findationWidget':
                window.dispatchEvent(
                  new CustomEvent('findationWidget', {
                    detail: {
                      event_name: actionName,
                      event_label: actionLabel
                    }
                  })
                );
                break;
              case 'analyticsIframeEvent':
                window.postMessage(message);
                break;
              default:
                return;
            }
          }
        },
        this.outputTarget
      );
    }

    return this.resizer;
  }
}
